var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"flex items-center justify-center gap-x-6 sm:justify-start"},_vm._l((2),function(i){return _c('li',{key:i},[_c('UISkeletonElement',{staticClass:"h-7 w-[140px]"})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }